import $http from "../../helpers/api";

// initial state
const state = {
  all: [],
  accessory: []
};

// getters
const getters = {
  get: state => state.accessory,
  getAll: state => state.all
};

const actions = {
  getAll({ commit }) {
    return new Promise((resolve, reject) => {
      $http.get("/accessories").then(resp => {
        commit("setAll", resp.data);
      });
      resolve();
    });
  }
};
const mutations = {
  setAll(state, data) {
    state.all = data;
  },
  clearAll(state) {
    state.all = [];
    state.accessory = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
